class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.isProcessingSort = false;

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    // Clear "no results" message if it exists and show loading state
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) {
        // If there's a "no results" message, replace it with loading state
        if (collection.classList.contains('collection--empty')) {
          collection.innerHTML = '<div class="loading-placeholder" style="text-align: center; padding: 4rem 2rem; color: #666;"><p>Loading results...</p></div>';
        }
        collection.classList.add('loading');
      }
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      console.log('Fetching URL:', url);
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      console.log('Updating URL hash with:', searchParams);
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const currentContainer = document.getElementById('ProductGridContainer');
    const newContainer = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer');
    
    if (!currentContainer) {
      console.warn('ProductGridContainer not found in DOM');
      return;
    }
    
    // If no new container in response, show "no results" message
    if (!newContainer) {
      const searchParams = new URLSearchParams(window.location.search);
      const searchTerm = searchParams.get('q') || '';
      const filters = Array.from(searchParams.entries())
        .filter(([key]) => key !== 'q' && key !== 'sort_by' && key !== 'section_id')
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
      
      let message = 'No results found';
      if (searchTerm && filters) {
        message = `No results found for "${searchTerm}" with applied filters`;
      } else if (searchTerm) {
        message = `No results found for "${searchTerm}"`;
      } else if (filters) {
        message = 'No results found for the applied filters';
      }
      
      currentContainer.innerHTML = `
        <div class="collection collection--empty" id="product-grid" data-id="template--collection">
          <div class="no-results-message" style="text-align: center; padding: 4rem 2rem; color: #666;">
            <h2 style="font-size: 1.8rem; margin-bottom: 1rem;">${message}</h2>
            <p style="font-size: 1.4rem;">Try adjusting your search terms or filters to find what you're looking for.</p>
          </div>
        </div>
      `;
      return;
    }
    
    currentContainer.innerHTML = newContainer.innerHTML;

    currentContainer
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHTML.getElementById('ProductCount');
    
    if (!countElement) {
      console.warn('ProductCount not found in response');
      return;
    }
    
    const count = countElement.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Only remove facets if new ones are found in the response (preserve filters when no products found)
    if (facetDetailsElementsFromFetch.length > 0) {
      // Remove facets that are no longer returned from the server
      Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
        if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
          currentElement.remove();
        }
      });
    }

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    // Only process facets if they exist in the response
    if (facetDetailsElementsFromFetch.length > 0) {
      const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
      const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

      facetsToRender.forEach((elementToRender, index) => {
        const currentElement = document.getElementById(elementToRender.id);
        // Element already rendered in the DOM so just update the innerHTML
        if (currentElement) {
          document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
        } else {
          if (index > 0) {
            const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
            // Same facet type (eg horizontal/vertical or drawer/mobile)
            if (elementToRender.className === previousElementClassName) {
              document.getElementById(previousElementId).after(elementToRender);
              return;
            }
          }

          if (elementToRender.parentElement) {
            document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
          }
        }
      });

      if (countsToRender) {
        const closestJSFilterID = event.target.closest('.js-filter').id;

        if (closestJSFilterID) {
          FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
          FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

          const newFacetDetailsElement = document.getElementById(closestJSFilterID);
          const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

          const isTextInput = event.target.getAttribute('type') === 'text';

          if (newElementToActivate && !isTextInput) newElementToActivate.focus();
        }
      }
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    
    // Always hide loading spinners and remove loading state after processing filters
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    
    // Remove loading state from grid container
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) {
        collection.classList.remove('loading');
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      
      // Find all matching elements on the page (there might be multiple)
      const targetElements = document.querySelectorAll(selector);
      
      targetElements.forEach((targetElement, index) => {
        targetElement.innerHTML = activeFacetsElement.innerHTML;
      });
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceElement = html.querySelector(selector);
      const targetElement = document.querySelector(selector);

      if (!sourceElement || !targetElement) return;

      targetElement.innerHTML = sourceElement.innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Ignore form updates if we're currently processing a sort change
    if (this.isProcessingSort) {
      console.log('Ignoring form update during sort processing');
      return;
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if(facetLink) {
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// Custom Sort Dropdown Functionality
document.addEventListener('DOMContentLoaded', function() {
  initCustomSortDropdown();
});

function initCustomSortDropdown() {
  // Handle both desktop and mobile sort dropdowns
  const sortDropdowns = document.querySelectorAll('.custom-sort-dropdown');
  
  sortDropdowns.forEach(dropdown => {
    const sortButton = dropdown.querySelector('.custom-sort-button');
    const sortPanel = dropdown.querySelector('.custom-sort-panel');
    const sortRadios = dropdown.querySelectorAll('.custom-sort-radio');

    if (!sortButton || !sortPanel) return;

    // Toggle dropdown
    sortButton.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent anchor default behavior
      e.stopPropagation();
      const isHidden = sortPanel.hasAttribute('hidden');

      // Close all other dropdowns first
      sortDropdowns.forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          const otherPanel = otherDropdown.querySelector('.custom-sort-panel');
          const otherButton = otherDropdown.querySelector('.custom-sort-button');
          if (otherPanel && otherButton) {
            otherPanel.setAttribute('hidden', '');
            otherButton.setAttribute('aria-expanded', 'false');
          }
        }
      });

      if (isHidden) {
        sortPanel.removeAttribute('hidden');
        sortButton.setAttribute('aria-expanded', 'true');
      } else {
        sortPanel.setAttribute('hidden', '');
        sortButton.setAttribute('aria-expanded', 'false');
      }
    });

    // Handle radio selection - only submit sort_by parameter
    sortRadios.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.checked) {
        // Close the dropdown
        sortPanel.setAttribute('hidden', '');
        sortButton.setAttribute('aria-expanded', 'false');

        // Get the form and create search params from current URL (active filters only)
        const form = this.closest('form');
        if (form) {
          // Set flag to prevent form input events during sort processing
          const facetForm = form.closest('facet-filters-form');
          if (facetForm) {
            facetForm.isProcessingSort = true;
          }

          const currentParams = new URLSearchParams(window.location.search);
          const searchParams = new URLSearchParams();

          console.log('Current URL params:', window.location.search);

          // Only preserve actual active filters from URL (not default values)
          for (const [key, value] of currentParams.entries()) {
            console.log('Processing param:', key, '=', value);

            // Skip price filter parameters completely when sorting
            if (key.includes('filter.v.price')) {
              console.log('Skipping price param:', key);
              continue;
            }
            // Skip old sort_by
            if (key === 'sort_by') {
              console.log('Skipping old sort_by:', value);
              continue;
            }
            // Skip section_id (used for AJAX rendering)
            if (key === 'section_id') {
              console.log('Skipping section_id');
              continue;
            }
            // Keep all other filters (color, brand, etc.)
            console.log('Keeping param:', key, '=', value);
            searchParams.append(key, value);
          }

          // Add the new sort_by value
          searchParams.set('sort_by', this.value);

          console.log('Final search params:', searchParams.toString());

          // Trigger the page render with updated sort parameter
          FacetFiltersForm.renderPage(searchParams.toString(), null);

          // Clear the flag after rendering completes
          setTimeout(() => {
            if (facetForm) {
              facetForm.isProcessingSort = false;
            }
          }, 1500);
        }
      }
    });
  });

  // Close dropdown when clicking outside (for this specific dropdown)
  document.addEventListener('click', function(e) {
    if (!sortPanel.hasAttribute('hidden') &&
        !sortPanel.contains(e.target) &&
        !sortButton.contains(e.target)) {
      sortPanel.setAttribute('hidden', '');
      sortButton.setAttribute('aria-expanded', 'false');
    }
  });

  // Close dropdown on Escape key (for this specific dropdown)
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !sortPanel.hasAttribute('hidden')) {
      sortPanel.setAttribute('hidden', '');
      sortButton.setAttribute('aria-expanded', 'false');
      sortButton.focus();
    }
  });

  });
}

// Price range slider initialization (works after AJAX re-renders)
function initPriceRange() {
  document.querySelectorAll('.simple-price-range').forEach(function (container) {
    // Skip if already initialized (same DOM element)
    if (container._priceRangeInit) return;
    container._priceRangeInit = true;

    var minRange = container.querySelector('.range-min');
    var maxRange = container.querySelector('.range-max');
    var minDisplay = container.querySelector('.price-display-min');
    var maxDisplay = container.querySelector('.price-display-max');
    var rangeFill = container.querySelector('.range-fill');
    var overlay = container.querySelector('.range-click-overlay');
    var hiddenMin = container.querySelector('.price-hidden-min');
    var hiddenMax = container.querySelector('.price-hidden-max');

    if (!minRange || !maxRange) return;

    var maxPrice = parseInt(minRange.getAttribute('max'));

    function updateDisplay() {
      var min = parseInt(minRange.value) || 0;
      var max = parseInt(maxRange.value) || maxPrice;
      if (minDisplay) minDisplay.textContent = Math.round(min);
      if (maxDisplay) maxDisplay.textContent = Math.round(max);
      if (rangeFill) {
        var minPct = (min / maxPrice) * 100;
        var maxPct = (max / maxPrice) * 100;
        rangeFill.style.left = minPct + '%';
        rangeFill.style.width = (maxPct - minPct) + '%';
      }
    }

    function syncHiddenInputs() {
      // Activate hidden inputs (add name if not yet set)
      if (hiddenMin && !hiddenMin.name) hiddenMin.name = hiddenMin.dataset.paramName;
      if (hiddenMax && !hiddenMax.name) hiddenMax.name = hiddenMax.dataset.paramName;
      // Set dollar values (Shopify expects dollars in URL params)
      if (hiddenMin) hiddenMin.value = parseInt(minRange.value) || 0;
      if (hiddenMax) hiddenMax.value = parseInt(maxRange.value) || maxPrice;
    }

    minRange.addEventListener('input', function () {
      var min = parseInt(this.value) || 0;
      var max = parseInt(maxRange.value) || maxPrice;
      if (min >= max) { min = max - 1; if (min < 0) min = 0; this.value = min; }
      syncHiddenInputs();
      updateDisplay();
    });

    maxRange.addEventListener('input', function () {
      var min = parseInt(minRange.value) || 0;
      var max = parseInt(this.value) || maxPrice;
      if (max <= min) { max = min + 1; if (max > maxPrice) max = maxPrice; this.value = max; }
      syncHiddenInputs();
      updateDisplay();
    });

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        var rect = e.target.getBoundingClientRect();
        var clickValue = ((e.clientX - rect.left) / rect.width) * maxPrice;
        var currentMin = parseInt(minRange.value);
        var currentMax = parseInt(maxRange.value);
        var midPoint = (currentMin + currentMax) / 2;
        if (clickValue < midPoint) {
          minRange.value = Math.round(clickValue);
        } else {
          maxRange.value = Math.round(clickValue);
        }
        syncHiddenInputs();
        updateDisplay();
        // Trigger form input event for facet-filters-form to pick up
        minRange.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    updateDisplay();
  });
}

// Init on page load
document.addEventListener('DOMContentLoaded', initPriceRange);

// Re-initialize after AJAX updates (when filters are applied)
if (typeof FacetFiltersForm !== 'undefined') {
  const originalRenderAdditionalElements = FacetFiltersForm.renderAdditionalElements;
  FacetFiltersForm.renderAdditionalElements = function(html) {
    originalRenderAdditionalElements.call(this, html);
    // Re-init custom dropdown and price range after content is updated
    setTimeout(function () {
      initCustomSortDropdown();
      // Reset init flags so price range re-initializes on new DOM elements
      document.querySelectorAll('.simple-price-range').forEach(function (el) { el._priceRangeInit = false; });
      initPriceRange();
    }, 100);
  };
}
